import { BreadcrumbItem } from '@components/atoms/ui-kit/breadcrumbs.tsx';
import { Axios } from '@utils/api/axios-instance.ts';
import { ResellerCustomerResponse } from '@utils/api/resellers/use-get-cutomer-reseller.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { PATHS } from 'src/router/paths';

export const buildResellerBreadcrumbTrail = async (
  resellerId: string
): Promise<BreadcrumbItem[]> => {
  try {
    const response = await Axios.get<ResellerCustomerResponse>(
      GET_URL(resellerId).reseller
    );

    const reseller = response.data.result;

    return [
      {
        id: 'resellers',
        name: 'Resellers',
        path: PATHS().RESELLER
      },
      {
        id: reseller.id,
        name: reseller.name,
        path: PATHS(reseller.id.toString()).RESELLER_CUSTOMER
      }
    ];
  } catch {
    return [
      {
        id: 'resellers',
        name: 'Resellers',
        path: PATHS().RESELLER
      }
    ];
  }
};
